export default __webpack_public_path__ + "static/media/team-utilization-chart-legend.24f55f7f.svg";